import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import NavigationModeMenu from "@insite/content-library/Components/NavigationModeMenu";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface NavigationModeSwitcherStyles {
    wrapper?: InjectableCss;
}

export const navigationModeSwitcherStyles: NavigationModeSwitcherStyles = {
 
}

const styles = navigationModeSwitcherStyles;

const NavigationModeSwitcher = () => {

    return (
        <>
           <StyledWrapper {...styles.wrapper}>
                <NavigationModeMenu/>
           </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: NavigationModeSwitcher,
    definition: {
        displayName: "Navigation Mode Menu Switcher",
        group: "Header",
    },
};

export default widgetModule;
